var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoProtectionStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2500_72)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.952 140.03C411.986 143.927 347.028 155.944 304.047 169.802C253.705 185.933 207.152 207.586 169.692 232.27L158 239.957L158.758 244.287C160.057 252.191 170.017 291.598 174.889 308.271C185.066 342.807 198.382 379.941 211.915 411.662C221.334 433.64 240.172 472.831 241.038 472.073C241.363 471.748 239.847 465.686 237.79 458.649C230.753 434.939 222.741 400.511 218.086 374.853C212.781 345.622 205.744 286.51 205.744 272.003V265.94L214.189 260.96C227.397 252.948 250.349 241.689 268.645 233.894C312.925 215.056 368.897 199.575 414.151 193.62C477.052 185.176 516.46 184.851 572.756 191.888C612.814 196.976 671.276 211.267 708.086 224.908C724.542 231.079 756.154 244.612 764.924 249.267C775.425 254.897 793.613 265.723 794.155 266.59C794.804 267.672 792.098 301.883 789.824 321.262C784.628 364.568 776.508 406.033 763.733 453.127C761.026 463.196 758.969 471.64 759.186 471.857C759.835 472.398 779.972 431.041 787.984 412.745C799.785 386.004 816.349 339.559 825.984 305.781C831.506 286.726 842.332 244.287 842.332 241.689C842.332 239.632 828.474 230.213 808.77 218.737C742.08 180.087 655.578 152.913 566.802 142.736C534.756 139.055 491.992 137.973 463.952 140.03Z",
    fill: "url(#paint0_linear_2500_72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.582 335.01C800.753 435.479 747.163 548.397 697.362 620.067C687.726 633.925 659.794 671.168 650.917 681.778C641.823 692.82 612.375 724.758 607.72 728.764C606.096 730.279 600.791 735.043 596.027 739.482C576.323 757.887 544.386 781.596 520.243 795.67C499.24 807.904 501.189 807.363 494.801 804.115C486.79 800.109 471.416 790.799 463.405 785.385C434.607 765.465 433.524 764.707 413.604 747.277C356.116 697.151 302.093 626.888 256.405 542.659C244.497 520.898 231.721 495.565 224.793 480.191C222.194 474.345 218.513 466.225 216.673 462.22C203.14 432.664 185.601 387.302 172.61 348.327C167.63 333.386 163.624 322.235 163.516 323.535C163.516 327.54 167.738 359.911 170.444 375.934C191.989 502.277 238.975 616.495 305.016 703.105C332.082 738.507 371.056 777.374 406.675 804.331C428.219 820.679 459.507 839.842 486.898 853.591L500.106 860.195L509.525 855.648C545.144 838.543 588.124 810.611 617.68 785.277C665.965 743.921 706.997 693.578 740.667 634.466C778.884 567.56 808.765 484.522 826.087 398.128C830.092 377.558 838.32 322.019 837.454 320.936C837.346 320.72 835.073 327.107 832.582 335.01Z",
    fill: "url(#paint1_linear_2500_72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.207 466.241C489.39 474.023 477.006 479.78 463.648 482.956C455.829 484.862 447.672 485.835 439.276 485.835H330.256V534.651H270.516V435.43H439.256C448.267 435.43 456.742 433.227 464.224 429.336C471.071 445.754 483.992 458.975 500.187 466.261L500.207 466.241Z",
    fill: "url(#paint2_linear_2500_72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.59 473.765C720.59 501.895 701.517 525.559 675.597 532.527C670.555 533.917 665.216 534.631 659.719 534.631H459.044L496.079 484.247H659.719C665.514 484.247 670.198 479.562 670.198 473.765C670.198 467.968 665.514 463.303 659.719 463.303H528.767C520.431 463.303 512.492 461.616 505.268 458.598C500.941 456.792 496.853 454.489 493.102 451.73C477.839 440.692 467.916 422.706 467.916 402.417C467.916 396.64 463.232 391.955 457.436 391.955H270.516L307.511 341.531H457.417C459.5 341.531 461.565 341.631 463.609 341.849C474.564 342.961 484.647 346.971 493.082 353.105C508.344 364.143 518.268 382.109 518.268 402.397C518.268 408.194 522.952 412.879 528.747 412.879H659.699C674.386 412.879 687.862 418.08 698.381 426.756C711.937 437.932 720.57 454.826 720.57 473.745L720.59 473.765Z",
    fill: "url(#paint3_linear_2500_72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.594 341.531L683.579 391.935H533.515C531.193 391.935 528.871 392.094 526.628 392.412C524.068 374.446 514.68 358.683 501.164 347.864C510.552 344.41 520.575 342.305 531.014 341.71C533.019 341.611 535.043 341.531 537.068 341.531H720.594Z",
    fill: "url(#paint4_linear_2500_72)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint5_linear_2500_72)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint6_linear_2500_72)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2500_72",
    x1: 500.166,
    y1: 138.999,
    x2: 500.166,
    y2: 472.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2500_72",
    x1: 500.517,
    y1: 320.931,
    x2: 500.517,
    y2: 860.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFDC0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05953C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2500_72",
    x1: 385.361,
    y1: 429.336,
    x2: 385.361,
    y2: 534.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ACE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C021"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2500_72",
    x1: 495.553,
    y1: 341.531,
    x2: 495.553,
    y2: 534.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8DA11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C021"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2500_72",
    x1: 610.879,
    y1: 341.531,
    x2: 610.879,
    y2: 392.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DA11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2500_72",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2500_72",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2500_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProtectionStation);
export default __webpack_public_path__ + "static/media/Logo_ProtectionStation.47dbcf5737c1e6a8275c43d5174ec259.svg";
export { ForwardRef as ReactComponent };